import React, { useEffect, useRef } from 'react';
import { FaBriefcase, FaEnvelope, FaRocket, FaShieldAlt, FaChartLine, FaJava, FaReact, FaDocker } from 'react-icons/fa';
import { SiSpringboot, SiPostgresql } from 'react-icons/si';
import './style.css';

const scrollToSection = (hash) => {
  if (hash === 'home' || hash === '') {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.history.pushState('', '', '/');
    return;
  }
  const el = document.getElementById(hash);
  if (el) {
    const offset = el.offsetTop - 80;
    window.scrollTo({ top: offset, behavior: 'smooth' });
    window.history.pushState('', '', `#${hash}`);
  }
};

const featuredTech = [
  { name: 'Spring Boot', Icon: SiSpringboot, color: '#6db33f' },
  { name: 'Java', Icon: FaJava, color: '#f89820' },
  { name: 'React', Icon: FaReact, color: '#61dafb' },
  { name: 'PostgreSQL', Icon: SiPostgresql, color: '#336791' },
  { name: 'Docker', Icon: FaDocker, color: '#2496ed' }
];

const features = [
  { Icon: FaRocket, title: 'Moderne Lösungen', desc: 'Skalierbare Enterprise-Apps' },
  { Icon: FaShieldAlt, title: 'Saubere Architektur', desc: 'Wartbar & erweiterbar' },
  { Icon: FaChartLine, title: 'Performance', desc: 'Schnell & zuverlässig' }
];

const Banner = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const heroNode = heroRef.current;
    if (heroNode) {
      heroNode.classList.add('visible');
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      },
      { threshold: 0.1 }
    );
    if (heroNode) observer.observe(heroNode);
    return () => {
      if (heroNode) observer.unobserve(heroNode);
    };
  }, []);

  return (
    <div className="banner-wrapper" ref={heroRef}>
      <section id="home" className="banner">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-intro">
              <span className="hero-badge">&lt;/&gt; FULL STACK ENTWICKLER</span>

              <h1 className="hero-title">
                Ich bin <span className="hero-title-accent">Entwickler</span>
              </h1>

              <p className="hero-description">
                Ich entwickle moderne Enterprise-Anwendungen mit Java, Spring Boot
                und React. Meine Lösungen sind skalierbar, performant und bereit für die Zukunft.
              </p>

              <div className="hero-actions">
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => scrollToSection('resume')}
                >
                  <FaBriefcase aria-hidden />
                  Projekte ansehen
                </button>
                <button
                  type="button"
                  className="btn-secondary"
                  onClick={() => scrollToSection('contact')}
                >
                  <FaEnvelope aria-hidden />
                  Kontakt aufnehmen
                </button>
              </div>
            </div>

            <div className="hero-features">
              {features.map(({ Icon, title, desc }) => (
                <div key={title} className="hero-feature">
                  <span className="hero-feature-icon" aria-hidden>
                    <Icon />
                  </span>
                  <strong>{title}</strong>
                  <span>{desc}</span>
                </div>
              ))}
            </div>

            <div className="hero-tech-strip" aria-label="Technologien">
              <p className="hero-tech-label">Ich arbeite mit modernen Technologien</p>
              <div className="hero-tech-grid">
                {featuredTech.map(({ name, Icon, color }) => (
                  <div key={name} className="hero-tech-card">
                    <span className="hero-tech-icon" style={{ color }}>
                      <Icon />
                    </span>
                    <span className="hero-tech-name">{name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Banner;
